import { Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { loginConfig } from '../utils/loginConfig.ts';

export const Login = () => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();

  if (isLoading) {
    return <Typography>Loading&hellip;</Typography>;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  // We do not set a `prompt` as auth0 will automatically infer which one we need
  // When a new user logs in, it will use the `consent` prompt which is needed for first time logins
  // After that it will use the `silent` login and not prompt them to do anything
  loginWithRedirect(loginConfig('/'));

  return <Typography>Loading&hellip;</Typography>;
};
